
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("g7YcF", function(module, exports) {

$parcel$export(module.exports, "HelpComponent", () => $b9e4f32820a8615c$export$5d792f79638040b8);
/* HelpComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");
var $js7oX = parcelRequire("js7oX");

var $beLpb = parcelRequire("beLpb");

var $inPa6 = parcelRequire("inPa6");

var $ci7Ox = parcelRequire("ci7Ox");

var $5izcQ = parcelRequire("5izcQ");

var $1kHsc = parcelRequire("1kHsc");
var $irVI7 = parcelRequire("irVI7");

var $dBcar = parcelRequire("dBcar");

var $9Yv8Z = parcelRequire("9Yv8Z");

var $7zgzO = parcelRequire("7zgzO");

var $7yPTi = parcelRequire("7yPTi");

var $bQIml = parcelRequire("bQIml");

var $dEBDF = parcelRequire("dEBDF");

var $ljm2R = parcelRequire("ljm2R");

var $bBQPT = parcelRequire("bBQPT");

var $jln20 = parcelRequire("jln20");

var $bQm3c = parcelRequire("bQm3c");

var $jmjWc = parcelRequire("jmjWc");
var $luv00 = parcelRequire("luv00");

var $9wGTI = parcelRequire("9wGTI");

var $efvKr = parcelRequire("efvKr");

var $de2j9 = parcelRequire("de2j9");
const $b9e4f32820a8615c$var$QuestionCircleIconContainer = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_6v241ixg _1v91kakq",
            __cmplp.className
        ])
    });
});
const $b9e4f32820a8615c$var$i18n = (0, $2nPZH.defineMessages)({
    help: {
        id: "app-navigation.help.tooltip",
        defaultMessage: "Help"
    },
    onboardingNudgeBody: {
        id: "app-navigation.onboarding.nudge.body",
        defaultMessage: "Find additional help by selecting the {helpEmoji} icon."
    }
});

const $b9e4f32820a8615c$var$HelpMenuLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "9C8Il",
    name: "HelpMenuLoader",
    loader: async ()=>(await (parcelRequire("eWAfu"))).HelpMenu
});
const $b9e4f32820a8615c$var$Help = ({ openDialog: openDialog, onClose: onCloseCallback, onClick: onClick, intl: intl, isOpen: isHelpComponentOpen })=>{
    const triggerButtonRef = (0, $gwFzn.useRef)(null);
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isNotesEnabled = isLoggedIn && (0, $9wGTI.fg)('confluence_notes');
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const inProductHelpContext = (0, $bBQPT.useInProductHelpActions)();
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { match: match, location: location } = (0, $gwFzn.useContext)((0, $7zgzO.RoutesContext));
    const [isInProductHelpOpen, setIsInProductHelpOpen] = (0, $gwFzn.useState)(false);
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)(); // if both apps are enabled, isOpen prop may not have the most up to date state
    if (isNotesEnabled) isHelpComponentOpen = rightSidebarContext.getCurrent()?.panelId === (0, $bBQPT.HELP_PANEL_ID);
    const onClose = (0, $gwFzn.useCallback)(()=>{
        onCloseCallback();
    }, [
        onCloseCallback
    ]);
    const openShortcutsDialog = ()=>openDialog((onClose)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bQIml.KeyboardShortcutsDialog), {
                onClose: onClose
            }));
    const handleClick = (0, $gwFzn.useCallback)(()=>{
        onClick(); // Check first if we're still in an "open" state from external contexts
        if (isHelpComponentOpen || isInProductHelpOpen) {
            // Check if the user had closed it via the IPH "X" button
            // -> No sidebar component open OR sidebar is not open with Help component
            if ((!rightSidebarContext.getCurrent() || rightSidebarContext?.getCurrent()?.panelId !== (0, $bBQPT.HELP_PANEL_ID)) && location) {
                rightSidebarContext.open((0, $bBQPT.HELP_PANEL_ID), (0, $bBQPT.HELP_PANEL_WIDTH));
                rightSidebarContext?.setTriggerButtonRef?.(triggerButtonRef);
            } else {
                setIsInProductHelpOpen(false);
                rightSidebarContext.close((0, $bBQPT.HELP_PANEL_ID));
                onClose();
            }
        } else if (location) {
            experienceTracker.start({
                name: (0, $irVI7.VIEW_IN_PRODUCT_HELP_EXPERIENCE),
                attributes: {
                    navVersion: '3'
                }
            });
            rightSidebarContext.open((0, $bBQPT.HELP_PANEL_ID), (0, $bBQPT.HELP_PANEL_WIDTH));
            rightSidebarContext?.setTriggerButtonRef?.(triggerButtonRef);
            const { routeName: routeName, routeGroup: routeGroup } = (0, $bBQPT.getRouteData)(location.pathname);
            inProductHelpContext.setRouteName(routeName);
            inProductHelpContext.setRouteGroup(routeGroup);
        }
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'globalNavigation',
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: 'help',
                attributes: {
                    selectedItemPageContext: match ? match.name : undefined,
                    navigationLayer: 'global',
                    navVersion: '3',
                    navdexPointType: (0, $dEBDF.START_TOUCH)
                }
            }
        }).fire();
    }, [
        isHelpComponentOpen,
        onClose,
        onClick,
        match,
        createAnalyticsEvent,
        rightSidebarContext,
        experienceTracker,
        inProductHelpContext,
        isInProductHelpOpen,
        location
    ]);
    const preloadMenu = ()=>{
        (0, $7yPTi.preloadHelpMenu)();
        $b9e4f32820a8615c$var$HelpMenuLoader.preload();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5izcQ.default), {
        name: "app-navigation-help"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("span", {
        "data-testid": "app-navigation-help",
        "data-pendo-id": "con-*/wiki/home-help",
        "data-vc": "app-navigation-help-button",
        ...ssrPlaceholderIdProp
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9Yv8Z.OnboardingCTANudge), {
        position: "bottom-end",
        offset: [
            3,
            8
        ],
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
            ...$b9e4f32820a8615c$var$i18n.onboardingNudgeBody,
            values: {
                helpEmoji: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($b9e4f32820a8615c$var$QuestionCircleIconContainer, {
                    "data-testid": "nudge-icon"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ci7Ox))), {
                    label: "help menu icon"
                }))
            }
        }),
        width: 280,
        source: "onboardingNudge",
        actionSubjectId: (0, $dBcar.HELP),
        renderChildrenWhileLoading: true,
        dataVC: "app-navigation-help-onboarding"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $beLpb.Help), {
        ref: triggerButtonRef,
        onClick: handleClick,
        onMouseEnter: preloadMenu,
        onFocus: preloadMenu,
        tooltip: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $b9e4f32820a8615c$var$i18n.help),
        isSelected: isHelpComponentOpen,
        "aria-label": intl.formatMessage($b9e4f32820a8615c$var$i18n.help),
        "aria-haspopup": true,
        "aria-expanded": isHelpComponentOpen
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ljm2R.GeneralShortcutListener), {
        accelerator: isLiveEditMode || isOnEditRoute ? (0, $ljm2R.UNIVERSAL_HELP_SHORTCUT) : [
            (0, $ljm2R.HELP_SHORTCUT),
            (0, $ljm2R.UNIVERSAL_HELP_SHORTCUT)
        ],
        listener: openShortcutsDialog,
        isAppNavigationShortcut: true
    })));
};
const $b9e4f32820a8615c$export$5d792f79638040b8 = (0, $js7oX.default)($b9e4f32820a8615c$var$Help);

});
parcelRegister("beLpb", function(module, exports) {

$parcel$export(module.exports, "Help", () => $e9d59b7cad9d10ee$export$1be7516c0280bee8);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $195qZ = parcelRequire("195qZ");

var $4qrTW = parcelRequire("4qrTW");

var $hslOl = parcelRequire("hslOl");

var $8MTIk = parcelRequire("8MTIk");
const $e9d59b7cad9d10ee$var$HELP_NOTIFICATION_BADGE_ID = 'atlassian-navigation-help-notification-count';
const $e9d59b7cad9d10ee$export$1be7516c0280bee8 = /*#__PURE__*/ (0, $gwFzn.forwardRef)((props, ref)=>{
    const { badge: badge, component: component, href: href, id: id, isDisabled: isDisabled, isSelected: isSelected, label: label, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, target: target, testId: testId, tooltip: tooltip, ...rest } = props;
    const { mode: { navigation: navigation } } = (0, $4qrTW.useTheme)();
    const button = /*#__PURE__*/ (0, $7UHDa.jsx)((0, $8MTIk.IconButton), {
        component: component,
        href: href,
        icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($195qZ))), {
            label: typeof tooltip === 'string' ? tooltip : 'Help Icon',
            color: "currentColor",
            spacing: "spacious",
            LEGACY_secondaryColor: navigation.backgroundColor
        }),
        id: id,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onMouseUp: onMouseUp,
        ref: ref,
        target: target,
        testId: testId,
        tooltip: tooltip,
        isTooltipAnnouncementDisabled: true,
        ...rest
    });
    return badge ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $hslOl.BadgeContainer), {
        id: $e9d59b7cad9d10ee$var$HELP_NOTIFICATION_BADGE_ID,
        badge: badge,
        role: "listitem",
        children: button
    }) : /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        role: "listitem",
        children: button
    });
});

});

parcelRegister("eWAfu", function(module, exports) {

let $ae1299b950a42beb$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $ae1299b950a42beb$var$load("1vHyq"),
    $ae1299b950a42beb$var$load("bkLxC"),
    $ae1299b950a42beb$var$load("3AkOk"),
    $ae1299b950a42beb$var$load("lfEn7"),
    $ae1299b950a42beb$var$load("4PQXU"),
    $ae1299b950a42beb$var$load("89mul"),
    $ae1299b950a42beb$var$load("6vzdH"),
    $ae1299b950a42beb$var$load("1epse"),
    $ae1299b950a42beb$var$load("5joXW"),
    $ae1299b950a42beb$var$load("c6MKV"),
    $ae1299b950a42beb$var$load("ffEVr"),
    $ae1299b950a42beb$var$load("joJy8"),
    $ae1299b950a42beb$var$load("aHE9G"),
    $ae1299b950a42beb$var$load("6H998")
]).then(()=>parcelRequire('bbp2J'));

});



//# sourceMappingURL=HelpComponent.86b0c2d2.js.map
